import script from "./baseline-category-bar-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./baseline-category-bar-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__